import postWithResponse from '@services/api/common/postWithResponse';
import getData from '@services/api/common/getData';
import appConfig from '@configs/appConfig';
import { customFields } from '@constants/appRoutes';

export const getItems = () => getData(`${appConfig.baseUrl}${customFields}`);

export const updateItems = data =>
  postWithResponse(`${appConfig.baseUrl}${customFields}`, data);
